import { useEffect, useState } from 'react';
import { TextField, Box, Button, CircularProgress } from '@mui/material';
import { Link, Navigate, useLocation } from 'react-router';
import { isEmpty } from 'lodash';

import { Pages } from '../../types/pages';
import { failure } from '../../types/api';

import { useAuth } from '../../utility/auth';
import { getQueryParams } from '../../utility/helper';

import './index.css';

const Start = () => {
  const auth = useAuth();
  const location: any = useLocation();
  const [code, setCode] = useState<string>('');
  const [error, setError] = useState<boolean>(false);

  const [failed, setFailed] = useState<string>('');

  const [starting, setStarting] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);

  const handleStart = (linkCode: string) => {
    if (linkCode.trim().length > 0 && linkCode.length < 200 && !isEmpty(linkCode)) {
      setCode(linkCode);
      setLoading(true);
    } else setError(true);
  };

  useEffect(() => {
    const params: { code?: string } = getQueryParams();
    if (params?.code != null) {
      handleStart(params.code);
    }
  }, []);

  useEffect(() => {
    const startSession = async () => {
      let data = await auth.login(code);
      setFailed('');
      if (data === failure) {
        setFailed('Failed to start session.');
      }

      setStarting(false);
      setLoading(false);
    };

    if (loading && !starting) {
      setStarting(true);
      startSession();
    }
  }, [loading, auth, code, starting]);

  useEffect(() => {
    document.getElementById('Code')?.focus();
  }, []);

  let sent = location.state?.sent ?? false;
  let from = location.state?.from?.pathname || '/';

  const onPaste = (e: any) => {
    handleStart(e.clipboardData.getData('text/plain'));
  };

  if (auth.user != null) return <Navigate to={from} />;
  else if (loading) return <CircularProgress />;
  return (
    <Box className="flex-form">
      {sent && <Box className="sent-message">If your account exists in our records, we sent a login code.</Box>}
      <TextField
        value={code}
        error={error}
        id="Code"
        sx={{ width: '300px' }}
        helperText={error && 'Invalid code.'}
        label="Code"
        autoComplete="off"
        inputProps={{ onPaste }}
        onChange={(e: any) => setCode(e.target.value)}
        onKeyDown={(e: any) => {
          if (e.code === 'Enter') {
            handleStart(code);
          }
        }}
      />
      <Button variant="contained" onClick={() => handleStart(code)}>
        Start
      </Button>
      {failed.length > 0 && <Box color="error.main">{failed}</Box>}
      <Link to={Pages.Login}>Need a login code?</Link>
    </Box>
  );
};

export default Start;
